import { render, staticRenderFns } from "./Prototypedesign.vue?vue&type=template&id=5161b855&scoped=true&"
import script from "./Prototypedesign.vue?vue&type=script&lang=js&"
export * from "./Prototypedesign.vue?vue&type=script&lang=js&"
import style0 from "./Prototypedesign.vue?vue&type=style&index=0&id=5161b855&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5161b855",
  null
  
)

export default component.exports